import React from 'react';
import {
  Menu,
  MenuItem,
} from '@mui/material';
import { SortState } from '../hooks/useSortableList';
import { SortCriterion } from '../common/utilities';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

interface MyActivitiesSortMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  sortCriteria: SortCriterion;
  SUPPORTED_SORTS: any[];
  selectedUserDataKey: string | null;
  handleSortOptionClick: (field: string) => void;
}

const MyActivitiesSortMenu: React.FC<MyActivitiesSortMenuProps> = ({
  open,
  anchorEl,
  onClose,
  sortCriteria,
  SUPPORTED_SORTS,
  selectedUserDataKey,
  handleSortOptionClick,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      {SUPPORTED_SORTS.map(
        ({ field, label, checkDisabled }) => (
          <MenuItem
            disabled={Boolean(
              checkDisabled && checkDisabled(selectedUserDataKey)
            )}
            key={field}
            value={field}
            onClick={() => handleSortOptionClick(field)}
            selected={
              sortCriteria[field] !== SortState.None &&
              Boolean(sortCriteria[field])
            }
          >
            {label(selectedUserDataKey)}
            {sortCriteria[field] !== SortState.None &&
              Boolean(sortCriteria[field]) && (
                <React.Fragment>
                  {sortCriteria[field] === SortState.Desc ? (
                    <ArrowDownwardIcon />
                  ) : (
                    <ArrowUpwardIcon />
                  )}
                </React.Fragment>
              )}
          </MenuItem>
        )
      )}
    </Menu>
  );
};

export default MyActivitiesSortMenu;
